import { useState, useEffect, useContext } from "react";
import { useForm } from "react-hook-form";
import { Button } from '@mui/material';
import { FormInputText } from '../../Form/FormInputText';
import { FormButtonSubmit } from "../../Form/FormButtonSubmit";
import { FormAutocomplete } from "../../Form/FormAutocomplete";
import { createSection, getListTemplate } from '../../../store/index.service';
import { StoreContext } from "../../../store/store";

export const CreateSection = ({ handleClosePopup, refreshData }) => {

    const { handleSubmit, control } = useForm();

    const { lang } = useContext(StoreContext);

    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [listTemplate, setListTemplate] = useState([]);

    useEffect(() => {
        getListTemplate().then(res => {
            setListTemplate(res.template);
        });

    }, []);

    const onSubmit = data => {

        setLoading(true);

        const formData = new FormData();
        
        for (const [key, value] of Object.entries(data)) {
            if (key === "template" && value)
                formData.append(key, value.title);
            else
                formData.append(key, value);
        }

        createSection(formData, lang)
            .then(() => {
                refreshData();
                handleClosePopup();
            })
            .catch(err => {
                console.error(err);
                setLoading(false);

                if(err.response.status === 409)
                    setErrorMsg(err.response.data.result);
                else
                    setErrorMsg("Une erreur est survenue");
            })
    }

    return (
        <div className='popupCreateHorseQuick'>

            <h2>Créer une section</h2>

            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form">
                    
                    <div className="row-form">
                        <FormInputText
                            name="title"
                            label="titre"
                            control={control}
                            defaultValue="titre"
                            rules={{ required: true }}
                        />
                        <FormAutocomplete
                            name="template"
                            control={control}
                            label="Template"
                            options={listTemplate}
                            getOptionLabel={el => el.title}
                            renderOption={(props, option) =>
                                <li {...props} key={option.title}>
                                    {option.title}
                                </li>
                            }
                        />
                    </div>

                </div>

                <div className="btn-container">

                    <Button 
                        variant="text"
                        color="grey"
                        size="small"
                        className="cancel"
                        onClick={handleClosePopup}
                    >
                        Annuler
                    </Button>

                    <FormButtonSubmit loading={loading} />

                </div>
            </form>
        </div>
    )
}